// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1VUkp","imageWrap":"_1FMne","cardDetail":"_37axi"};